import { useRef } from "react";
import { useRecoilState } from "recoil";

import ToggleSwitch from "src/common/components/toggleSwitch";
import { useTranslation } from "src/hooks/translation";
import mainStore from "src/stores/main";
import InfoIcon from "src/common/components/infoIcon";

import './style.scss';

const FreeBetToggle = () => {
  const t = useTranslation();
  const [mainState, setMainState] = useRecoilState(mainStore);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const toggleFreeBetEnabled = () => setMainState({
    ...mainState,
    isFreeBetEnabled: !mainState.isFreeBetEnabled,
  });

  return (
    <div className="B-betslip-free-bet-toggle" ref={wrapperRef}>
      <h4>
        <i className="global-icon icon-free-bonus" />
        {t('Free bet')}
      </h4>

      <InfoIcon offset={8} anchorRef={wrapperRef}>
        <div className="B-betslip-free-bet-toggle-info">
          <i className="global-icon icon-attention-circle" />
          <p>{t(mainState.isFreeBetEnabled ? 'Switch off the toggle to use real money.' : 'Switch on the toggle to place a free bet.')}</p>
        </div>
      </InfoIcon>

      <ToggleSwitch onChange={toggleFreeBetEnabled} checked={mainState.isFreeBetEnabled} />
    </div>
  );
};

export default FreeBetToggle;